import React, { useEffect, useState } from "react";
import Header from "../../CommonComponents/header";
import { Footer } from "../../CommonComponents/footer";
import { MobileHeader } from "../../CommonComponents/mobileHeader";
import AOS from "aos";
import "aos/dist/aos.css";
import { baseurl } from "../../CommonComponents/baseurl";
import { Img } from "../../subComponents/img";
import { Grid, Skeleton } from "@mui/material";
import { Heading } from "../../subComponents/Heading";
import { MainHeading } from "../../subComponents/MainHeading";
import { Text } from "../../subComponents/text";

const RecentProjectPage = () => {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  const [currentbanner, setCurrentBanner] = useState(null);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const response = await fetch(`${baseurl}/api/our-projects`, {
          method: "GET",
        });

        const data = await response.json();
        if (data.success === "1") {
          setCurrentBanner(data.data);
        } else {
          console.error("Failed to currentbanner data:", data.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchBanner();
  }, []);

  useEffect(() => {
    console.log("currentbanner:", currentbanner);
  }, [currentbanner]);

  return (
    <>
      <Header />
      <MobileHeader />
      <div className="desktop_header_spacer"></div>

      <section className="blog_hero_section becaom_dealer_hero_section">
        <div className="blog_hero_banner">
          <img
            src={"/assets/images/new_images/banners/blog_banner.jpg"}
            alt={"blog.png"}
            width={"100%"}
          />
        </div>
        <div className="blog_hero_banner_overlay">
          <div className="innerblog_hero_content">
            <Heading title={"RECENT PROJECTS"} />
          </div>
        </div>
      </section>

      <br />
      <br />
      <div style={{ width: "80%", margin: "auto", maxWidth: "1300px" }}>
        <MainHeading
          style={{ textalign: "center" }}
          title={"Recent Projects"}
        />
      </div>
      <br />
      <br />
      <div className="recent_project_page_section">
        {currentbanner === null ? (
          <Grid
            container
            rowSpacing={3}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            {Array.from(new Array(8)).map((_, index) => (
              <Grid item xs={6} sm={4} md={4} lg={4} key={index}>
                <Skeleton
                  variant="rectangular"
                  sx={{
                    maxWidth: 350,
                    maxHeight: "300px",
                    minHeight: "300px",
                    mx: "auto",
                  }}
                />
                <Skeleton
                  variant="text"
                  style={{ height: "40px", width: "200px", margin: "auto" }}
                ></Skeleton>
              </Grid>
            ))}
          </Grid>
        ) : (
          currentbanner.map((items) => {
            return (
              <>
                {/* <div
                  className="recent_projects_all"
                  data-aos="flip-left"
                  data-aos-easing="ease-out-cubic"
                  data-aos-duration="2000"
                >
                  <Img
                    src={items.image}
                    alt={"recent project"}
                    style={{ zIndex: "-1" }}
                  />
                    <div className="recent_project_button">
                      <Subheading
                        title={items.title}
                        style={{
                          textTransform: "uppercase",
                        }}
                      />
                    </div>
                </div> */}

                <div
                  className="recent_project"
                  data-aos="flip-left"
                  data-aos-easing="ease-out-cubic"
                  data-aos-duration="2000"
                >
                  <div className="home_recent_project_image">
                    <Img
                      src={items.image}
                      style={{ zIndex: "-1" }}
                      alt={items.title}
                    />
                  </div>

                  <div style={{ textDecoration: "none" }}>
                    <div
                      className="recent_project_button"
                      style={{ justifyContent: "start" }}
                    >
                      <div style={{ height: "220px", maxHeight: "220px" }}>
                        {" "}
                        <p
                          style={{
                            textAlign: "start",
                            textTransform: "uppercase",
                            lineHeight: "1rem",
                          }}
                        >
                          {items?.title}
                        </p>
                        <Text
                          text={
                            items?.city === null ? "city name" : items?.city
                          }
                          style={{
                            textAlign: "start",
                            fontSize: "1rem",
                            lineHeight: "0.5rem",
                          }}
                        />
                        <br />
                        <p
                          dangerouslySetInnerHTML={{
                            __html: items?.description,
                          }}
                          style={{
                            textAlign: "start",
                            fontSize: "1rem",
                            fontWeight: "300",
                          }}
                        />
                        <div
                          style={{
                            textAlign: "start",
                            fontSize: "1rem",
                            fontWeight: "300",
                            display: "flex",
                            gap: "0.4rem",
                          }}
                        >
                          {}
                          {[...Array(5)].map((_, index) => {
                            const ratingValue = index + 1;
                            const isFilled = ratingValue <= items?.rating;

                            return (
                              <span
                                key={index}
                                className={
                                  isFilled ? "orange_star" : "gray_star"
                                }
                              >
                                {}
                                &#9733;
                              </span>
                            );
                          })}

                          <br />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          })
        )}
      </div>
      <div style={{ height: "3rem" }}></div>
      <Footer />
    </>
  );
};
export default RecentProjectPage;
